import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-indigo-900 flex items-center justify-center">
          <div className="text-center p-8 bg-white bg-opacity-10 backdrop-blur-md rounded-xl border border-red-400">
            <h2 className="text-2xl font-bold text-red-400 mb-4">Algo salió mal</h2>
            <p className="text-white mb-4">Ha ocurrido un error inesperado.</p>
            <button
              onClick={() => window.location.reload()}
              className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-bold transition"
            >
              Recargar Página
            </button>
            <details className="mt-4 text-left">
              <summary className="text-purple-300 cursor-pointer">Detalles del error</summary>
              <pre className="text-xs text-red-300 mt-2 bg-black bg-opacity-30 p-2 rounded">
                {this.state.error?.toString()}
              </pre>
            </details>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
